import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
const Wrapper = styled.div`
  .body {
    height: 0;
    overflow: hidden;
    &.open {
      height: auto;
    }
  }
  .header {
    cursor: pointer;
    padding: 8px 0;
  }
  .sub-header {
    margin-left: 8px;
  }
  .icon-wrapper {
    margin-left: 16px;
  }
`;

const PanelToggle = ({ header, subHeader, open, onToggle, children, className, expandable }) => {
  let isExpandable = true
  if (expandable === false) {
    isExpandable = false
  }
  return (
    <Wrapper className={className}>
      <div className="header flex" onClick={() => onToggle(!open)}>
        <div className="flex-1 md:flex">
          <div className="font-bold flex-1">{header}</div>
          <div className="sub-header font-light">{subHeader}</div>
        </div>
        {isExpandable && <div className="self-center icon-wrapper">
          <FontAwesomeIcon
            className="cursor-pointer text-green"

            icon={open ? faChevronUp : faChevronDown}
          />
        </div>}
      </div>
      <div className={`body ${open && 'open'}`}>{children}</div>
    </Wrapper>
  );
};

export default PanelToggle;
